export const EXECUTE_USER_LOGIN = 'EXECUTE_USER_LOGIN'  // 用户--登录
export const EXECUTE_USER_LOGOUT = 'EXECUTE_USER_LOGOUT'  // 用户--退出登录
export const LOGOUT_CART_CLEAR = `LOGOUT_CART_CLEAR` // 退出登录时,清空购物车
export const SET_WX_JS_URL = `SET_WX_JS_URL` // 设置进入微信时jssdk所需的URL
export const SET_NAVIGATION_TITLE = `SET_NAVIGATION_TITLE` // 设置进入webapp时的标题
export const SET_AUTH_TB_ACCOUNT_INFO = `SET_AUTH_TB_ACCOUNT_INFO` // 设置授权的淘宝账户信息